import styled from 'styled-components'
import { Card, CardBody, CardHeader, Heading, Text, Flex, Link, Image } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import FoldableText from 'components/FoldableSection/FoldableText'

const MustachioedMan = () => {
  return <Image src="/images/Saly-11.png" alt="drawing of a mustachioed man" width={367} height={367} />
}

const Wrapper = styled(Flex)`
  width: 100%;
  margin: auto;
  padding: 0 24px 72px 24px;
  flex-direction: column-reverse;
  align-items: center;

  ${({ theme }) => theme.mediaQueries.xl} {
    flex-direction: row;
    max-width: 1140px;
  }
`

const StyledCardbody = styled(CardBody)`
  div:first-child {
    margin-top: 0px;
  }
`

const InlineLink = styled(Link)`
  display: inline-block;
  margin: 0 4px;
`

const FAQ = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <MustachioedMan />
      <Card>
        <CardHeader>
          <Heading color="secondary" scale="lg">
            {t('FAQ')}
          </Heading>
        </CardHeader>
        <StyledCardbody>
          <FoldableText title={t('What types of prizes can be won on LFGames ?')} mt="24px">
            <Text fontSize="14px" color="textSubtle">
              {t(
                'Our platform supports the ability to offer a variety of different prizes, including ERC20 tokens and ERC721 tokens for NFTs.',
              )}
            </Text>
          </FoldableText>
          <FoldableText title={t('How can I be sure to receive the prize if I win the contest ?')} mt="24px">
            <Text fontSize="14px" color="textSubtle">
              {t(
                'Thanks to blockchain and smart contracts, prizes are uploaded before the game starts, ensuring that they are available and transparently managed.',
              )}
              {t(
                'All our Smart Contract are public and verified. You can check all deployed smart contract source code on our GitHub repository.',
              )}
            </Text>
          </FoldableText>
          <FoldableText
            title={t('How is the time range for the daily action game calculated for Daily Action Game ?')}
            mt="24px"
          >
            <Text fontSize="14px" color="textSubtle">
              {t(
                'The time range is randomly generated by our smart contract, and is managed by the game creator. It can vary between 2 hours and 8 hours a day. Each day, the time slot for each player is randomly selected by our smart contract, at a predefined time selected by the contest creator.',
              )}
            </Text>
          </FoldableText>
          <FoldableText title={t('How long does a game typically last ?')} mt="24px">
            <Text mt="16px" bold>
              {t('Classic Giveaway Contest')}
            </Text>
            <Text fontSize="14px" color="textSubtle">
              {t(
                'The winners will be randomly selected when the maximum number of players is met. The length of the game can vary depending on the size and engagement of the community, but it can take a few minutes to a few days.',
              )}
            </Text>
            <Text mt="16px" bold>
              {t('Daily Action Game')}
            </Text>
            <Text fontSize="14px" color="textSubtle">
              {t(
                'The length of a game can vary depending on the number of players and other factors. During our tests, games with 10 players and 2 prizes lasted between 2 and 5 days.',
              )}
            </Text>
          </FoldableText>
          <FoldableText title={t("Can I stop playing a game if I don't want to continue ?")} mt="24px">
            <Text fontSize="14px" color="textSubtle">
              {t(
                'The time range is randomly generated by our smart contract, and is managed by the game creator. It can vary between 2 hours and 8 hours a day. Each day, the time slot for each player is randomly selected by our smart contract, at a predefined time selected by the contest creator.',
              )}
            </Text>
          </FoldableText>
          <FoldableText title={t('How long does a game typically last ?')} mt="24px">
            <Text mt="16px" bold>
              {t('Classic Giveaway Contest')}
            </Text>
            <Text fontSize="14px" color="textSubtle">
              {t(
                'Once your participation is validated, you cannot remove it. However, if you win and do not want to claim your prize, you can choose not to do so.',
              )}
            </Text>
            <Text mt="16px" bold>
              {t('Daily Action Game')}
            </Text>
            <Text fontSize="14px" color="textSubtle">
              {t('Yes, you can stop playing a game at any time, but you will lose the game.')}
            </Text>
          </FoldableText>
          <FoldableText title={t('When will the contests be launched in production ?')} mt="24px">
            <Text fontSize="14px" color="textSubtle">
              {t(
                'We want to ensure that our smart contracts are secure before launching the contests in production. We hope to win a hackathon or find a community that can help us make it a reality. If you are interested in partnering with us or contributing to the project, please contact us on Twitter.',
              )}
            </Text>
          </FoldableText>
          <FoldableText title={t(' What is the fee structure for creating a contest on LFGames ?')} mt="24px">
            <Text fontSize="14px" color="textSubtle">
              {t(
                'The fee structure for creating a contest on LFGames varies depending on the type of contest and the amount of prize money being offered. Our platform charges a small percentage fee to creators for hosting their contests on the platform.',
              )}
            </Text>
          </FoldableText>

          <FoldableText title={t('Can i contact you for partnership ?')} mt="24px">
            <Text>
              {t('For sur! Please feel free to reach out to us on')}
              <InlineLink fontSize="14px" external href="https://twitter.com/0xGeegZ">
                {t('Twitter')}
              </InlineLink>
              {t('or')}
              <InlineLink fontSize="14px" external href="https://www.linkedin.com/in/guillaumedieudonne/">
                {t('LinkedIn')}
              </InlineLink>
            </Text>
          </FoldableText>
        </StyledCardbody>
      </Card>
    </Wrapper>
  )
}

export default FAQ
